import React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet, Navigate } from 'react-router-dom';
import './App.css';

import SiteFooter from './components/SiteFooter';
import Home from './pages/Home';
import BookList from './pages/BookList';
import Reader from './pages/Reader';
import Fuzou from './pages/fuzou/fuzoulist';
import FuzouHushen from './pages/fuzou/hushen';
import FuzouBeidou from './pages/fuzou/beidou';
import FuzouZhanjiang from './pages/fuzou/zhanjiang';
import FuzouXianglong from './pages/fuzou/xianglong';
import FuzouFuhua from './pages/fuzou/fuhua';
import FuzouTianshen from './pages/fuzou/tianshen';
import FuzouDisan from './pages/fuzou/disan';
import FuzouYinshen from './pages/fuzou/yinshen';
import Fulu from './pages/fulu/fululist';
import Qiucai from './pages/fulu/qiucai';
import Qiuguan from './pages/fulu/qiuguan';
import Xueye from './pages/fulu/xueye';
import Courses from './pages/courses/courseslist';

// 通用布局组件
function LayoutWithNavbar() {
  return (
    <>
      <Outlet />
      <SiteFooter />
    </>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        {/* 阅读器页面 - 独立布局 */}
        <Route path="/books/:id/read" element={<Reader />} />
        
        {/* 其他页面 - 通用布局 */}
        <Route element={<LayoutWithNavbar />}>
          <Route path="/" element={<Home />} />
          <Route path="/category/:categoryId" element={<BookList />} />
          <Route path="/books" element={<BookList />} />
          <Route path="/fuzou" element={<Fuzou />} />
          <Route path="/fuzou/hushen" element={<FuzouHushen />} />
          <Route path="/fuzou/beidou" element={<FuzouBeidou />} />
          <Route path="/fuzou/zhanjiang" element={<FuzouZhanjiang />} />
          <Route path="/fuzou/xianglong" element={<FuzouXianglong />} />
          <Route path="/fuzou/fuhua" element={<FuzouFuhua />} />
          <Route path="/fuzou/tianshen" element={<FuzouTianshen />} />
          <Route path="/fuzou/disan" element={<FuzouDisan />} />
          <Route path="/fuzou/yinshen" element={<FuzouYinshen />} />
          <Route path="/fulu" element={<Fulu />} />
          <Route path="/fulu/qiucai" element={<Qiucai />} />
          <Route path="/fulu/qiuguan" element={<Qiuguan />} />
          <Route path="/fulu/xueye" element={<Xueye />} />
          <Route path="/courses" element={<Courses />} />
          {/* /books/:id 重定向到阅读页面 */}
          <Route path="/books/:id" element={<Navigate to="/books/:id/read" replace />} />
          <Route path="*" element={
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <h1>404 - 页面不存在</h1>
              <p>抱歉，您访问的页面不存在。</p>
            </div>
          } />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
